/** @format */

import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[commonAutoATags]',
})
export class AutoATagDirective implements AfterViewInit {
  constructor(private elemRef: ElementRef) {}

  ngAfterViewInit(): void {
    const linkAnchorTags = this.elemRef.nativeElement.querySelectorAll('a');
    const linkAnchorTagsArray = Array.from(linkAnchorTags);

    if (linkAnchorTagsArray && linkAnchorTagsArray.length > 0) {
      linkAnchorTagsArray.forEach((item) => {
        this.createDataEm(item);
        this.checkATag(item);
      });
    }
  }

  createDataEm(item: any) {
    // eslint-disable-next-line no-useless-escape
    const itemText = item.innerText.replace(/[.,\/#!$%\^&\*;:'{}=\-_`~()\s]/g, '');
    const page = window.location.pathname;
    const strippedPage = page.substring(page.lastIndexOf('/') + 1);

    item.setAttribute('data-em', `sp_${strippedPage}_${itemText}`);
  }

  checkATag(item: any) {
    const ref = item.getAttribute('href');

    const emailObj = {
      condition: ref.includes('mailto:'),
      title: `${item.innerText} (opens email application)`,
      target: '',
      href: ref,
    };
    this.changeATag(emailObj, item);

    const telepObj = {
      condition: ref.includes('tel:'),
      title: `${item.innerText} (opens telephone application)`,
      target: '',
      href: ref,
    };
    this.changeATag(telepObj, item);

    const nonRelativeObj = {
      condition: ref.includes('http') && ref.includes('://'),
      title: `${item.innerText} (opens in a new window)`,
      target: '_blank',
      href: ref,
    };
    this.changeATag(nonRelativeObj, item);

    const elseyObj = {
      condition: !emailObj.condition && !telepObj.condition && !nonRelativeObj.condition,
      title: item.innerText,
      target: '',
      href: ref,
    };
    this.changeATag(elseyObj, item);
  }

  changeATag(linkParams, item) {
    if (linkParams.condition) {
      item.setAttribute('title', linkParams.title);
      item.setAttribute('target', linkParams.target);
      item.setAttribute('href', linkParams.href);
    }
  }
}
